import { Injectable } from "@angular/core";

import { UtilsService } from "@core/services/utils/utils.service";

import { DocSetting } from "./document.model";
import { TypeUtilService } from "@core/services/utils/type-util.service";

@Injectable()

export class DocumentSettingsService {

  private settings: Map<string, any> = new Map();

  constructor(
    private readonly utilService: UtilsService
  ) {
  }

  setSettings(settings: DocSetting[], clear = true) {
    if (clear) {
      this.settings.clear();
    }

    settings.forEach((setting) => {
      this.settings.set(setting.name, TypeUtilService.isLogical(setting.value) ? TypeUtilService.isTruthy(setting.value) : setting.value);
    })
  }


  getSetting(key: string) {
    return this.settings.get(key);
  }

  getSettingAgreeRules() {
    return {
      enabled: this.settings.get('AGREE_RULES/ENABLED'),
      text: this.settings.get('AGREE_RULES/TEXT'),
      url: this.settings.get('AGREE_RULES/URL')
    }
  }
}
